import moment from "moment";
import { randomUUID } from "@/utils/util";
import { model } from "eco-cli";
const User = model.UserInfo;
const Image = model.Image;
const File = model.File;
// console.log(User.fromStr())
// debugger

export class Comment {
  static blank(json = {}) {
    return new this({
      commentId: randomUUID(),
      ...json,
    });
  }

  constructor(json) {
    Object.assign(this, json);
  }

  static fromServer(json) {
    return new Comment({
      commentId: json.id,
      content: json.content,
      html: json.html,
      createTime: moment(json.createTime).format("YYYY-MM-DD HH:mm:ss"),

      createUser: User.new({
        nickname: json.userName,
        uid: json.createBy,
        avatar: Image.avatar(json.avatar),
        isExpert: json.isExpert
      }),

      replyUser: User.new({
        nickname: json.returnName,
        isExpert: json.isExpert
      }),
      
    });
  }
  
  commentId = "";
  content = "";
  html = "";
  createUser = User.blank();
  createTime = moment();

  image = null; // 题图 默认文章第一张图
  fileList = [];

  toServer() {
    return {
      dataId: this.worksheetId, // 工单id
      id: this.commentId, // 回复id
      content: this.content,
      html: this.html,
      fileList: this.fileList || [],
    };
  }
}

// 状态类
class Status extends model.Model {
  // 已提交 1
  // 处理中(已接收) 2
  // 待评价(已解决) 3
  // 已完成 4
  // 已撤单 5

  // 用户去掉已接收状态
  static getStatus(status) {
    return parseInt(status) - 1
  }

  // 状态名
  static getStatusName = (status) => {
    switch (Status.getStatus(status)) {
      case 0:
        return '已提交'
      case 1:
        return '处理中'
      case 2:
        return '待评价'
      case 3:
        return '已完成'
      case 4:
        return '已撤单'
      default:
        break
    }
  }

  // 状态圆颜色
  static getStatusColor(status) {
    switch (Status.getStatus(status)) {
      case 0:
        return '#4771F8'
      case 1:
        return '#FFC53D'
      case 2:
        return '#F88C47'
      case 3:
        return '#2FAA76'
      case 4:
        return '#222222'
      default:
        break
    }
  }

}

export class Worksheet {
  static blank() {
    return new this({});
  }

  constructor(json) {
    Object.assign(this, json);
  }

  static fromServer(json) {
    return new Worksheet({
      worksheetId: json.id || "",
      name: json.title || "",
      content: json.content,
      productType: json.productType || null,
      productTypeName: json.productTypeName || "",
      version: json.productVersion || "",
      status: Status.getStatus(json.status),
      statusName: Status.getStatusName(json.status),
      statusColor: Status.getStatusColor(json.status),
      submitTime: moment(json.createTime).format("YYYY-MM-DD HH:mm:ss"),
      email: json.email,
      phone: json.contactPhone,
      contacter: json.contactName,
      os: json.os,
      cpu: json.cpu,
      html: json.html,
    });
  }

  toServer() {
    return {
      id: this.worksheetId,
      title: this.name,
      content: this.content,
      productType: this.productType,
      productVersion: this.version,
      // status: this.status,
      html: this.html,
      email: this.email,
      contactPhone: this.phone,
      contactName: this.contacter,
      os: this.os,
      cpu: this.cpu
    };
  }

  worksheetId = ""; // 工单编号
  name = ""; // 问题描述
  content = ""; // 问题详情
  productType = null; // 所属产品
  version = "" // 产品版本号
  os = "" // 操作系统
  cpu = "" // cpu
  status = "";
  statusName = "";
  statusColor = ""
  submitTime = moment();
  submiter = User.blank() // 提交人
  contacter = "" // 联系人
  phone = ""
  email = ""
  html = "" // 问题详情html
}

// 
class WorkOrder extends model.Model {
  worksheetId = "" // 工单编号
  companyName = "" // 单位名称
  contactPhone = "" // 联系电话
  content = "" // 问题详情
  createBy = "" // 创建人
  email = "" // 邮箱
  html = "" // 	返回给页面的内容 
  os = "" // 操作系统
  productType = null // 产品类型
  productTypeName = "" // 产品类型名称
  productVersion = "" // 产品版本
  status = "" // 工单状态
  submitTime = "" // 	创建时间
  title = "" // 问题描述
  cpu = "" // cpu类型

  static fromServer(json) {
    return WorkOrder.new({
      worksheetId: json.id,
      companyName: json.companyName,
      contactPhone: json.contactPhone,
      contacter: json.contactName,
      content: json.content,
      createBy: json.createBy,
      email: json.email,
      html: json.html,
      os: json.os,
      productType: json.productType,
      productTypeName: json.productTypeName,
      productVersion: json.productVersion,
      status: Status.getStatus(json.status),
      statusName: Status.getStatusName(json.status),
      submitTime: json.submitTime,
      title: json.title,
      cpu: json.cpu,
    })
  }
}

export class WorksheetDetail extends model.Model {
  commentModelList = {}
  workOrderModel = {}

  static newData(json) {
    return WorksheetDetail.new({
      workOrderModel: WorkOrder.fromServer(json.workOrderModel),
      commentModelList: {}
    })
  }

  static fromServer(json) {
    return WorksheetDetail.newData(json)
  }
}